export default __webpack_public_path__ + "static/media/triggersDefault.3fed57af.jpg";